require('../modules/web.dom-collections.iterator');
require('../modules/es.string.iterator');
var isIterable = require('../internals/is-iterable');

module.exports = isIterable;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/is-iterable.js
// module id = 1015
// module chunks = 0